import { AxiosError } from "axios";
import { isUnauthorizedError, redirectToAuth } from "./utils";

export const makeRejectResponse = (authWebURL: string) => async (error: AxiosError): Promise<unknown> => {
  if (isUnauthorizedError(error)) {
    redirectToAuth(authWebURL);
  }

  return Promise.reject(error);
};
